module.exports = __webpack_public_path__ + "static/media/crisis-situations-large.5e3d9948.png";